import { render, staticRenderFns } from "./ScenarioMenuExport.vue?vue&type=template&id=1230b57f&scoped=true"
import script from "./ScenarioMenuExport.vue?vue&type=script&lang=js"
export * from "./ScenarioMenuExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1230b57f",
  null
  
)

export default component.exports